/*
 * Abba & Co. page components:
 * <abba-info> (info pages: sections and related links) and
 * <abba-note-preview> (Gift a cap: the gift note preview).
 */

if (!customElements.get('abba-info')) {
  customElements.define(
    'abba-info',
    class AbbaInfo extends HTMLElement {
      connectedCallback() {
        const links = [...this.querySelectorAll('[data-toc-link]')];
        const sections = [...this.querySelectorAll('[data-info-sec]')];
        if (!links.length || !sections.length) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const mark = () => {
          let active = 0;
          sections.forEach((sec, i) => {
            if (sec.getBoundingClientRect().top < 180) active = i;
          });
          links.forEach((link, i) => {
            if (i === active) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        };
        links.forEach((link, i) =>
          link.addEventListener('click', (event) => {
            const target = sections[i];
            if (!target) return;
            event.preventDefault();
            window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 140, behavior: reduce ? 'auto' : 'smooth' });
            history.replaceState(null, '', `#${target.id}`);
          })
        );
        window.addEventListener('scroll', mark, { passive: true });
        mark();
      }
    }
  );
}

if (!customElements.get('abba-note-preview')) {
  customElements.define(
    'abba-note-preview',
    class AbbaNotePreview extends HTMLElement {
      connectedCallback() {
        const input = this.querySelector('[data-note-input]');
        const preview = this.querySelector('[data-note-preview]');
        if (!input || !preview) return;
        const sync = () => {
          const text = input.value;
          const empty = !text.trim();
          preview.textContent = empty ? 'Your words will appear here.' : text;
          preview.classList.toggle('is-empty', empty);
        };
        input.addEventListener('input', sync);
        sync();
      }
    }
  );
}
